import { DocumentFile } from './document-file';

export enum DataRecordSource {
  UploadedDocument = 'UPLOADED_DOCUMENT',
  VendorData = 'VENDOR_DATA',
}

export enum VendorDataClassification {
  Original = 'Original',
  Reclassified = 'Reclassified',
  Restated = 'Restated',
}

export class VendorDataRecord extends DocumentFile {
  source: DataRecordSource;
  reportingInterval: string;
  isReclassified: boolean;
  classification: VendorDataClassification;
  isSuperseded: boolean;
  supersededBy: number;
  // Set on a statement received but not yet opened (no document yet): the id that opens it.
  pendingStatementId?: number | null;
  // Set on a superseded row whose newer version has not been opened yet: the id that opens that one.
  supersededByPendingStatementId?: number | null;
}
